import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const DetalleNivelT = props => {
  return (
    <option dato1={props.elemento.codigoTipoDoc} value={props.elemento.numeroDocum}>{props.elemento.descrRecurso}</option>
  )
  };

const ListaT = ({styles, handleLista, list}) => {
  const Nivel1DetalleT = list.map((elemento, _id) => <DetalleNivelT elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tecnico" id="miListaT" onChange={handleLista}>
        <option style={styles.input} value="">Seleccionar...</option>
        {Nivel1DetalleT}
      </select>
    </div>
  )
};

const DetalleNivelR = props => {
  return (
    <option dato1={props.elemento.codigoTipoDoc} value={props.elemento.numeroDocum}>{props.elemento.descrRecurso}</option>
  )
  };

const ListaR = ({styles, handleLista, list}) => {
  const Nivel1DetalleR = list.map((elemento, _id) => <DetalleNivelR elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="recaudo" id="miListaR" onChange={handleLista}>
        <option style={styles.input} value="">Seleccionar...</option>
        {Nivel1DetalleR}
      </select>
    </div>
  )
};

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoDpto} value={props.elemento._id}>{props.elemento.descrDpto}</option>
)
};

const Lista = ({styles, handleLista, list}) => {
    // console.log(list)
    const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista" onChange={handleLista}>
                <option style={styles.input} value="">Seleccionar...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};

const DetalleNivel3 = props => {
    return(
        <option dato1={props.elemento.codigoCiudad} value={props.elemento.codigoCiudad}>{props.elemento.nombreCiudad}</option>
    )
}

const DetalleNivel2 = ({styles, elemento, handleLista1}) => {
    const Nivel3Detalle = elemento.ciudades.map((elemento, i) => <DetalleNivel3 styles={styles} elemento={elemento} key={i} />);
    return (
        <select className="ui simple selection dropdown fluid" name="dpto" id="miLista1" onChange={handleLista1}>
        <option value="">Seleccionar...</option>
        {Nivel3Detalle}
    </select>
    )
  };

const ListaCi = ({styles, handleLista1, list, argsSelDpto}) => {
    var Nivel2Detalle = []
    list.forEach((elemento, _id) => {
        if(elemento._id===argsSelDpto._id){
            let niv2Det = []
            niv2Det.push(elemento)
            Nivel2Detalle = niv2Det.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} handleLista1={handleLista1}/>);
        }
    })
    return(
        <div>
            {!argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Seleccionar..." ?
                <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista1" onChange={handleLista1}>
                    <option style={styles.input} value="">Seleccionar...</option>
                    {Nivel2Detalle}
                </select>
            :
                <div>
                    {Nivel2Detalle}
                </div>
            }
        </div>
    )
};

//
const DetalleNivel5 = props => {
    return(
        <option dato1={props.elemento.codigoZona} value={props.elemento.codigoZona}>{props.elemento.nombreZona}</option>
    )
}

const DetalleNivel4 = ({styles, elemento, handleLista2}) => {
    var Nivel5Detalle = []
    var niv5Det = []
    // const Nivel5Detalle = elemento.zonas.map((elemento, i) => <DetalleNivel5 styles={styles} elemento={elemento} key={i} />);
    elemento.zonas.forEach((elemento1, i) => {
        if(elemento1.codigoZona){niv5Det.push(elemento1)}
    })
    Nivel5Detalle = niv5Det.map((elemento, i) => <DetalleNivel5 styles={styles} elemento={elemento} key={i} />);
    return (
        <select className="ui simple selection dropdown fluid" name="dpto" id="miLista2" onChange={handleLista2}>
            <option value="">Seleccionar...</option>
            {Nivel5Detalle}
        </select>
    )
  };

const ListaZo = ({styles, handleLista2, list, argsSelCiu}) => {
    // console.log(argsSelCiu)
    var Nivel4Detalle = []
    list.forEach((elemento, _id) => {
        if(argsSelCiu._id && elemento.ciudades.length>0 && elemento._id===argsSelCiu._id){
            elemento.ciudades.forEach((elemento1, i) => {
                // console.log(elemento1.codigoCiudad)
                // console.log(argsSelCiu.codigoCiudad)
                // if(argsSelCiu.codigoCiudad && elemento1.zonas[i].codigoZona && elemento1.codigoCiudad===argsSelCiu.codigoCiudad){
                if(argsSelCiu.codigoCiudad && elemento1.codigoCiudad===argsSelCiu.codigoCiudad){
                    // console.log(argsSelCiu)
                    // console.log(elemento1.zonas[i].codigoZona)
                    let niv4Det = []
                    niv4Det.push(elemento)
                    Nivel4Detalle = niv4Det.map((elemento, _id) => <DetalleNivel4 elemento={elemento1} key={elemento._id} handleLista2={handleLista2}/>);
                }
            })
        }
    })
    return(
        <div>
            {!argsSelCiu.nombreCiudad||argsSelCiu.nombreCiudad==="Seleccionar..." ?
                <select style={styles.input} className="ui simple selection dropdown fluid" name="dpto" id="miLista2" onChange={handleLista2}>
                    <option style={styles.input} value="">Seleccionar...</option>
                    {Nivel4Detalle}
                </select>
            :
                <div>
                    {Nivel4Detalle}
                </div>
            }
        </div>
    )
};
//

const AddBarr2 = ({styles, list, list1, handleLista, handleLista1, handleLista2, handleListaT, handleListaR,
                  handleSubmit, handleChange, args, argsSelDpto, argsSelCiu, errors}) => {
    let lisTEC = list1
    lisTEC = lisTEC.filter(elemento => elemento.tiporec.areaAprovech==='TECNICA')
    let lisREC = list1
    lisREC = lisREC.filter(elemento => elemento.tiporec.areaAprovech==='RECAUDO')

    return(
        <div>
            <button className="ui right labeled icon button" style={styles.titBuscar}>
                <i className="large plus yellow icon"></i>
                Barrio nuevo
            </button>
            <div style={styles.box}>
                <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
                    <div className="ui one column stackable grid">
                            <div className="row container">
                                <div className="column" width="100%">
                                <Form.Field>
                                    <label style={styles.label}>Código</label>
                                    <input style={styles.input} autoComplete="off" name="codigoBarrio" id="codigoBarrio" onChange={handleChange} placeholder='Código' icon={!errors.length?null: _find(errors, {path:'codigoBarrio'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Descripción</label>
                                    <input style={styles.input} autoComplete="off" name="nombreBarrio" id="nombreBarrio" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'nombreBarrio'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Area de aprovechamiento - TECNICA</label>
                                    <ListaT styles={styles} handleLista={handleListaT} list={lisTEC}/>
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Area de aprovechamiento - RECAUDO</label>
                                    <ListaR styles={styles} handleLista={handleListaR} list={lisREC}/>
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Departamento</label>
                                    <Lista list={list} styles={styles} handleLista={handleLista} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Ciudad</label>
                                    <ListaCi list={list} styles={styles} handleLista1={handleLista1} argsSelDpto={argsSelDpto}/>
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Zona</label>
                                    <ListaZo list={list} styles={styles} handleLista2={handleLista2} argsSelCiu={argsSelCiu}/>
                                </Form.Field>

                                <Button style={styles.confirmar} type='submit' primary fluid>
                                AGREGAR
                                </Button>

                                {
                                    errors.length?<Message negative header="Los siguientes errores:"
                                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                                }
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default AddBarr2
